import { useEffect, useState } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import { generatePath, useNavigate, useParams } from "react-router-dom";
// img
import { useGetFeedbackStepDetailQuery, useSubmitReportMutation } from "store/services/clients/assessmentTreatmentPlan";
import LoadingIndicator from "components/shared/LoadingIndicator";
import ErrorComponent from "components/shared/ErrorComponent";
import LoadingOverlay from "components/shared/LoadingOverlay";
import { getPdfBlob, successMessageToast } from "helpers/common";
import { CLIENT_REPORT_TYPES, REPORT_QUESTIONS } from "config/constants";
import { TREATMENT_PLAN, TREATMENT_PLAN_START_SESSION } from "config/paths";
import LoadingButton from "components/shared/LoadingButton";
import RenderAnswer, { RenderAnswerByQId } from "components/shared/ReportComponents/AnswerFields/Index";
import ClientDetails from "components/shared/ReportComponents/ClientDetails";
import KhanReportLogo from "components/shared/ReportComponents/KhanReortLogo";
import HeaderPreview from "components/shared/ReportComponents/ReportHeader/Preview";
import { clientListingPath } from "helpers/navigationHelper";
import { REPORT_SUBMITTED_SUCCESS } from "config/messages";
import { AssessmentTreatmentPlanPdfDoc } from "components/PDF/Clients/Reports/AssessmentTreatmentPlanPdf";
import { useUploadFileMutation } from "store/services/utility";
import TherapistSignature from "components/shared/ReportComponents/TherapistSignature";
import { store } from "store/store";
import SaveForLaterBtn from "components/shared/ReportComponents/SaveForLaterBtn";
import moment from "moment";

const ClientTreatmentPlanReportPreview = () => {

  const [isSubmitting, setSubmitting] = useState(false);
  const [isSaveLater, setSaveLater] = useState(false);

  const isVeteran = store.getState()?.auth?.user?.role_type === "veteran";

  const navigate = useNavigate();
  const { assessmentId, clientId, clientType } = useParams();

  const [submitReport] = useSubmitReportMutation();
  const [uploadFile] = useUploadFileMutation();

  const { data, isLoading, isFetching, isError, refetch } = useGetFeedbackStepDetailQuery({ assessmentId, clientId, clientType });
  const assessmentGoals = data?.assesmentData?.reportGoals;
  const assessmentAssignedId = data?.assesment?.id;
  const reportQuestions = data?.assesmentData?.reportQuestions;
  const reportAnswers = data?.assesmentData?.reportAnswers;

  const caseDiscipline = data?.clientPendingCaseload?.clientCaseloadTherapist?.caseDiscipline;
  const caseTherapist = data?.clientPendingCaseload?.clientCaseloadTherapist?.clientCaseloadMapping?.find(x => x.caseTherapist?.therapist_detail?.type == "veteran")?.caseTherapist;
  const therapistDetails = { caseDiscipline, caseTherapist }

  useEffect(() => {
    refetch();
  }, [refetch]);

  const handleClickBack = () => {
    navigate(
      generatePath(TREATMENT_PLAN, {
        assessmentId,
        clientId,
        clientType
      })
    );
  }

  const handleSubmitReport = async () => {
    try {
      setSubmitting(true);
      const doc = (
        <AssessmentTreatmentPlanPdfDoc
          data={data}
        />
      )
      const filename = `Assessment and Treatment Plan - ${caseDiscipline?.assign_term} - ${moment(new Date()).format("YYYY-MM-DD")}.pdf`
      let pdfFile = await getPdfBlob(doc, false, filename)

      let uploadedFileName = await uploadFile({ file: pdfFile, acl: "private", fileOriginalFormat: true }).unwrap();

      if (!uploadedFileName) {
        throw new Error("File not uploaded");
      }

      const payload = {
        assessmentAssignedId,
        data: {
          attachment_key: uploadedFileName,
          attachment_name: CLIENT_REPORT_TYPES[assessmentId].name,
        },
        clientType
      }

      await submitReport(payload).unwrap();
      successMessageToast(REPORT_SUBMITTED_SUCCESS);
      navigate(clientListingPath(clientType));
    } catch (err) {
      setSubmitting(false);
      console.error("Error submitting report", err);
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <>
      <section className="ReportSec py-3 position-relative">
        {/* {data && (
            <PDFViewer style={{ width: "100%", height: "900px" }}>
              <AssessmentTreatmentPlanPdfDoc
                data={data}
              />
            </PDFViewer>
          )} */}
        <Container fluid>
          <Row>
            <Col lg="12" className="my-2">
              <div className="cardCstm p-lg-5 rounded-2 bg-white shadow">
                {isLoading ? (
                  <LoadingIndicator />
                ) : isError ? (
                  <ErrorComponent />
                ) : (
                  <>
                    {isFetching && <LoadingOverlay />}
                    <HeaderPreview
                      heading={data?.assesment?.report_heading}
                    />
                    <div className="formBody pt-3">
                      <div className="">
                        <div className="py-3">
                          <div
                            className="cardCstm rounded-2 px-3"
                            style={{ background: "#F9F9F9" }}
                          >
                            <ClientDetails
                              data={data}
                              showAssessmentDate={false}
                            />
                          </div>
                        </div>
                        {reportQuestions?.length > 0 &&
                          reportQuestions?.map((question, index) => {
                            let foundAnswer = reportAnswers?.length && reportAnswers.find(answer => answer.question_id === question.id);
                            if (
                              [
                                REPORT_QUESTIONS.greeting,
                                REPORT_QUESTIONS.summary,
                                REPORT_QUESTIONS.recommendation,
                              ].includes(question.id)
                            ) {
                              return null;
                            }

                            return (
                              <RenderAnswer
                                key={index}
                                question={question}
                                answer={foundAnswer}
                              />
                            );
                          })
                        }
                        <div className="py-3">
                          <div className="d-flex align-items-center gap-10 mt-3">
                            <h6 className="m-0 fw-sbold themeBlue pb-1">
                              Discipline
                            </h6>
                            <input
                              type="text"
                              value={
                                therapistDetails?.caseDiscipline
                                  ?.name
                              }
                              className="form-control text-dark fw-bold text-center"
                              style={{
                                background: "#e9e9e9",
                                maxWidth: 220,
                              }}
                              readOnly
                            />
                          </div>

                          {assessmentGoals?.length > 0 &&
                            assessmentGoals?.map((goal, index) => (
                              <div className="py-3">
                                <div
                                  className="cardCstm rounded-3 p-3"
                                  style={{ background: "#FBFBE6" }}
                                >
                                  <div className="top d-flex align-items-start">
                                    <h5 className="m-0 fw-bold themeBlue">
                                      {index + 1}.
                                    </h5>
                                    <div className="px-3">
                                      <h5 className="m-0 pb-1 fw-sbold themeBlue border-bottom">
                                        Area
                                      </h5>
                                      <p className="m-0 themeBlue pt-1">
                                        {
                                          goal
                                            ?.assesmentGoalDisciplineArea
                                            ?.name
                                        }
                                      </p>
                                    </div>
                                    <div className="px-3">
                                      <h5 className="m-0 pb-1 fw-sbold themeBlue border-bottom">
                                        Goal
                                      </h5>
                                      <p className="m-0 themeBlue pt-1">
                                        {goal?.assesmentGoalDetail?.title}
                                      </p>
                                    </div>
                                    <div className="px-3">
                                      <h5 className="m-0 pb-1 fw-sbold themeBlue border-bottom">
                                        Context
                                      </h5>
                                      <p className="m-0 themeBlue pt-1">
                                        {
                                          goal?.assesmentGoalContext
                                            ?.context
                                        }
                                      </p>
                                    </div>
                                  </div>
                                  <div className="bottom pt-4">
                                    <h5 className="m-0 fw-bold themeBlue mb-3">
                                      Goal Details
                                    </h5>
                                    <div
                                      className="px-lg-4 p-3 rounded-3"
                                      style={{ background: "#F2F3DA" }}
                                    >
                                      <p className="m-0 themeBlue">
                                        {goal?.goal_description}
                                      </p>
                                    </div>
                                  </div>
                                  <div className="bottom pt-4">
                                    <h5 className="m-0 fw-bold themeBlue mb-3">
                                      Goal Review
                                    </h5>
                                    <div
                                      className="px-lg-4 p-3 rounded-3"
                                      style={{ background: "#F2F3DA" }}
                                    >
                                      <p className="m-0 themeBlue">
                                        {goal?.goal_notes}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ))}
                        </div>
                        <RenderAnswerByQId
                          questionId={REPORT_QUESTIONS.summary}
                          reportQuestions={reportQuestions}
                          reportAnswers={reportAnswers}
                        />

                        <RenderAnswerByQId
                          questionId={REPORT_QUESTIONS.recommendation}
                          reportQuestions={reportQuestions}
                          reportAnswers={reportAnswers}
                        />

                        <RenderAnswerByQId
                          questionId={REPORT_QUESTIONS.greeting}
                          reportQuestions={reportQuestions}
                          reportAnswers={reportAnswers}
                          showQuestion={false}
                        />
                      </div>
                      <div className="py-3">
                        <TherapistSignature
                          therapistDetails={therapistDetails}
                        />
                      </div>
                      <div className="py-3">
                        <KhanReportLogo />
                      </div>
                    </div>
                  </>
                )}
              </div>
            </Col>
            <Col lg="12" className="my-2 d-flex gap-10">
              <Button
                style={{
                  background: "rgb(69, 163, 165)",
                  borderColor: "rgb(69, 163, 165)",
                }}
                onClick={handleClickBack}
                disabled={!!isSubmitting || !!isSaveLater}
                className="d-flex align-items-center justify-content-center commonBtn fw-sbold"
              >
                Back
              </Button>
              {
                isVeteran && (
                  <SaveForLaterBtn
                    assessmentAssignedId={assessmentAssignedId}
                    clientType={clientType}
                    isLoading={!!isSubmitting}
                    setSaveLater={setSaveLater}
                  />
                )
              }
              {
                isVeteran && <LoadingButton
                  className="d-flex align-items-center justify-content-center commonBtn"
                  onClick={handleSubmitReport}
                  isLoading={isSubmitting}
                  disabled={!!isSaveLater}
                >
                  Submit
                </LoadingButton>
              }
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default ClientTreatmentPlanReportPreview;
